// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles-module--menu--3FFqX"};